import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = true, requireConsent = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-[#FBF9F6]">
        <div className="text-stone-400 text-xs uppercase tracking-[0.3em]">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace state={navState} />;
  if (requireConsent && !user.terms_accepted_at) return <Navigate to="/consent" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
